module.exports = {
    // basic
    'rig': 'Plataforma',
    'rigs': 'plataformas',
    'a-rig': 'una plataforma',
    'filters': 'filtros',
    'reset-filters': 'reajustar filtros',
    'reset': 'reajustar',
    'show-all': 'mostrar todo',
    'yes': 'si',
    'no': 'no',
    'on': 'prender',
    'off': 'apagar',
    'add': 'agregar',
    'edit': 'editar',
    'all': 'todo',
    'selected': 'seleccionado',
    'delete': 'borrar',
    'delete-all': 'borrar todos',
    'delete-selected': 'borrar seleccionado',
    'download': 'descargar',
    'download-all': 'descargar todos',
    'download-selected': 'descarga seleccionada',
    'export': 'exportar',
    'open': 'abierto',
    'close': 'cerca',
    'menu': 'menú',
    'mon': 'lu',
    'tue': 'ma',
    'wed': 'mi',
    'thu': 'ju',
    'fri': 'vi',
    'sat': 'sa',
    'sun': 'do',
    'time-zone': 'zona horaria',
    'a-time-zone': 'una zona horaria',
    'save': 'guardar',
    'ok': 'ok',
    'cancel': 'cancelar',
    'company': 'compañía',
    'companies': 'compañías',
    'a-company': 'una compañía',
    'asset': 'bien',
    'assets': 'los bienes',
    'an-asset': 'un bien',
    'pad': 'patín',
    'pads': 'los patínes',
    'a-pad': 'un patín',
    'state': 'estado',
    'states': 'estados',
    'a-state': 'un estado',
    'field': 'campo',
    'fields': 'campos',
    'a-field': 'un campo',
    'country': 'país',
    'countries': 'países',
    'a-country': 'un país',
    'well': 'pozo',
    'wells': 'pozos',
    'a-well': 'un pozo',
    'column-options': 'opciones de columna',
    'drilling': 'perforacion',
    'completion': 'terminacion',
    'flowback': 'contraflujo',
    'audited': 'auditado',
    'legalHold': 'legal retención',
    'legalHold-success': 'legal hold success',
    'legalHold-error': 'legal hold error',
    'workover': 'reparaciones',
    'production': 'producción',
    'any': 'cualquiera',
    'apply-filters': 'aplicar filtros',
    'well-stage': 'etapa de pozo',
    'a-well-stage': 'un etapa de pozo',
    'start': 'comienzo',
    'end': 'fin',
    'date': 'fecha',
    'entry-type': 'tipo de entrada',
    'rejected': 'rechazado',
    'approved': 'aprobado',
    'template': 'plantilla',
    'mobile': 'móvil',
    'hours': 'horas',
    'days': 'dias',
    'new': 'nuevo',
    'a-company-to-view-wells': 'una compañía para ver los pozos',
    'a-company-to-view-entry-types': 'una compañía para ver los tipos de entrada',
    'entry-type-to-view-doc-approval-steps': 'un tipo de entrada para ver los pasos de aprobación',
    'a-column': 'un columna',
    'well-property': 'propiedad del pozo',
    'well-properties': 'propiedades del pozo',
    'a-well-property': 'un propiedad del pozo',
    'select': 'seleccione',
    'a-saved-search': 'una búsqueda guardada',
    'an-entry-type': 'un tipo de entrada',
    'entry-types': 'tipos de entrada',
    'username': 'nombre de usuario',
    'uploaded-by': 'subido por',
    'uploaded-on': 'subido en',
    'files': 'archivos',
    'size': 'tamaño',
    'sticky': 'resaltar entrada en la parte superior de la lista',
    'dont-send-alerts': 'no mandar alertas',
    'email': 'correo electronico',
    'filename': 'nombre del archivo',
    'name': 'nombre',
    'upload-date': 'fecha de carga',
    'preserve-upload-date': 'preservar fecha de carga',
    'approval-status': 'estado de aprobación',
    'remarks': 'observaciones',
    'approved-by': 'aprobado por',
    'approval-date': 'fecha de aprobación',
    'approve': 'aprobar',
    'reject': 'rechazar',
    'search-by': 'buscar por',
    'additional-columns': 'columnas adicionales',
    'spud-date': 'fecha de perforacion',
    'add-date': 'añadir fecha',
    'elevation': 'elevación',
    'county': 'condado',
    'projected-depth': 'profundidad proyectada',
    'a-template': 'una plantilla',
    'approvals': 'aprobaciones',
    'department-or-role': 'departamento o oficio',
    'approval-steps': 'pasos de aprobación',
    'an-entry-type-group': 'un grupo de tipo de entrada',
    'entry-type-group': 'grupo de tipo de entrada',
    'user': 'usuario',
    'users': 'usuarios',
    'entries': 'entradas',
    'upload': 'cargar',
    'access-review': 'revisión de acceso',
    'entry-audit': 'auditoría de entrada',
    'notifications': 'notificaciones',
    'search': 'buscar',
    'doc-approval-search': 'búsqueda de aprobación de documentos',
    'report': 'informe',
    'all-reports': 'todos los informes',
    'reports-i-created': 'reportes creados',
    'reports-i-receive': 'reportes recibidos',
    'my-account': 'mi cuenta',
    'recycle-bin': 'papelera de reciclaje',
    'help': 'ayuda',
    'succeeded': 'triunfado',
    'failed': 'ha fallado',
    'saved': 'salvado',
    'first-name': 'primer nombre',
    'last-name': 'apellido',
    'email-address': 'correo electrónico',
    'a-cell-carrier': 'un operador de telefonía',
    'cell-carrier': 'operador de telefonía',
    'cell-phone': 'celular',
    'office-phone': 'telefono de oficina',
    'address': 'dirección',
    'city': 'ciudad',
    'province': 'provincia / región',
    'grouping-preference': 'usar la vista agrupar por tipo de entrada de forma predeterminada',
    'wells-per-page': 'pozo por página',
    'language': 'idioma',
    'password': 'contraseña',
    'confirm-password': 'confirmar contraseña',
    'files-per-entry': 'archivos por entrada',
    'column': 'columna',
    'save-search': 'guardar búsqueda',
    'search-name': 'buscar nombre',
    'session-expired': 'su sesión ha caducado.',
    'session-expiring': 'tu sesión está a punto de terminar.',
    'role': 'oficio',
    '404-home': 'volver a inicio',
    '404-support': 'contactar soporte',
    'months': 'meses',
    'limits': 'limites',
    'edited': 'fecha de edición',
    'edited-by': 'editado por',
    'edit-date': 'fecha de edición',
    'select-all': 'seleccionar todo',
    'preview': 'avance',
    'last-24-hours': 'últimas 24 horas',
    'last-login': 'último acceso',
    'international': 'internacional',
    'change-password': 'cambia la contraseña',
    'actions': 'comportamiento',
    'well-header-info': 'información del encabezado del pozo',
    'added': 'agregar fecha',
    'added-by': 'añadido por',
    'columns': 'columnas',
    'prod-data': 'datos de producción',
    'no-change': '- No change -',
    'state': 'condado',
    'states': 'condados',
    'a-state': 'un condado',
    //// sidebar only
    'entry-type-access': 'acceso a tipo de entrada',
    'my-company': 'mi compañía',
    'reports': 'informes',
    'sign-out': 'cerrar sesión',
    'home': 'hogar',

    // raw
    'entry-type-required': 'Seleccione un tipo de entrada.',
    'wellbore-audit-template-required': 'Seleccione una plantilla de auditoría de pozos.',
    'time-zone-required': 'Seleccione una zona horaria.',
    'company-required': 'Por favor seleccione una empresa.',
    'no-pdf-selected': 'No existen archivos PDF en las entradas seleccionadas.',
    'no-pdf-found': 'No se encontraron archivos PDF.',
    'unable-reach-server': 'No se puede llegar al servidor.',
    'enter-username': 'Por favor, ingrese un nombre de usuario.',
    'enter-password': 'Porfavor ingrese una contraseña.',
    'enter-password-confirm': 'Debes confirmar tu contraseña.',
    'first-name-empty': 'Debes ingresar un nombre.',
    'last-name-empty': 'Debes ingresar un apellido.',
    'enter-valid-phone-number': 'Por favor escriba un numero de teléfono valido.',
    'enter-valid-nonusa-phone-number': 'Por favor ingrese un número de teléfono de oficina internacional válido.',
    'validate-select-entry-type': 'Debes seleccionar un tipo de entrada.',
    'enter-valid-email': 'Por favor escriba un correo electrónico valido.',
    'doc-approval-report-pending-all-help': 'Mostrar entradas pendientes de aprobación para todos los pasos (entradas "nuevas").',
    'doc-approval-report-pending-selected-help': 'Mostrar entradas pendientes de aprobación para los pasos seleccionados.',
    'doc-approval-report-pending-any-help': 'Muestra las entradas pendientes de aprobación para cualquier paso.',
    'doc-approval-report-rejected-status-help': 'Muestra las entradas que han sido rechazadas, independientemente de los pasos aprobados.',
    'doc-approval-report-approved-status-help': 'Muestra las entradas que tienen todos los pasos aprobados.',
    'doc-approval-report-pending-status-help': 'Muestra las entradas que aún tienen aprobaciones pendientes.',
    'doc-approval-report-any-status-help': 'Realice una selección en <b>Estado de aprobación</b>.',
    'error-404-general': 'Lo sentimos, se ha producido un error. No se encontró la pagina solicitada.',
    'download-fail': 'Descarga fracasó.',
    'no-selection': 'Nada se ha seleccionado.',
    'start-date-less-than-end-date': 'La Fecha de Inicio debe ser menor o igual que la Fecha de Finalización',
    'date-panel-help': `
        <p class="h4">
            Rango
        </p>
        <div class="alert alert-warning">
            <dl class="help-definition-list">
                <dt>
                    Cualquiera
                </dt>
                <dd>
                    Deje ambas casillas en blanco.
                </dd>
                <dt>
                    Fecha exacta
                </dt>
                <dd>
                    Ingrese el mismo valor tanto en <b>Comienzo</b> como en <b>Fin</b>.
                </dd>
                <dt>
                    Antes de una fecha
                </dt>
                <dd>
                    Ingrese solo el valor <b>Fin</b>.
                </dd>
                <dt>
                    Después de una fecha
                </dt>
                <dd>
                    Ingrese solo el valor de <b>Comienzo</b>.
                </dd>
                <dt>
                    Entre dos fechas
                </dt>
                <dd>
                    Ingrese valores diferentes tanto en <b>Comienzo</b> como en <b>Fin</b>.
                </dd>
            </dl>
        </div>
    `,
    'grid-no-items': 'No hay elementos para mostrar',
    'filter-collapse': 'Escoge entre las condiciones de filtrar, abajo, después hace clic en <b>Applicar Filtros</b>.  Haga clic en <b>Despejar Filtros</b> en cualquier momento para eliminar todo los filtros.',
    'grid-items-per-page': 'artículos por página',
    'session-expired-continue': `Haga clic en <b>Ok</b> para volver a la página de inicio de sesión.`,
    'session-timeout-status': 'Tu sesión terminará en',
    'session-continue': `Haga clic en <b>Ok</b> para continuar con su sesión actual.`,
    'tbd': 'TBD',
    'not-tbd': 'No TBD ',
    'combined-pdf': 'PDF Combinado',
    'usa': 'EE. UU.',
    'user-time-zone-help': `
        La selección de <b>Zona horaria</b> afectará las selecciones de fecha y hora en los criterios de búsqueda, así como la programación, en las páginas que contienen esas funciones, donde se indique. Si está presente, las opciones de zona horaria en cualquier página individual anularán esta configuración.<br />
        La zona horaria predeterminada es CST.
    `,
    'group-name-required': `Introduzca un nombre de grupo.`,
    'status-required': `Por favor seleccione un estado.`,
    'insufficient-permissions': 'Hubo un problema con su cuenta. Comuníquese con WellDrive Operations al <a href="tel:(877) 704-827">(877) 704-827</a> o envíeles un correo electrónico a ops@welldrive.com para obtener ayuda.',

    // template
    // Special Kendo-only template.
    'grid-item-count': '{0} - {1} de {2} artículos',
    'cell-carrier-required-if-cell-number': (words) => `<b>${words[0]}</b> debe tener una selección si <b>${words[1]}</b> no está vacío.`,
    'cell-number-required-if-cell-carrier': (words) => `<b>El teléfono celular</b> no debe estar vacío si <b>el portador celular</b> no está vacío`,
    'session-timeout-explain': (words) => `Como medida de seguridad, las sesiones terminan después de ${words[0]} minuto de inactividad.`,
    'less-than-number-of-characters': (words) => `${words[0]} debe tener menos de ${words[1]} caracteres.`,
    'corrupt-pdf': (words) => `No se pudo agregar el archivo "${words[0]}" al PDF combinado. Por favor asegúrate de que el archivo no esté dañado.`,
    'download-too-big': (words) => `El tamaño total de los archivos que está intentando descargar supera el límite de ${words[0]} MB. Cambie su selección e inténtelo nuevamente, o comuníquese con Operaciones de WellDrive para obtener ayuda.`,
    'confirm-delete-saved-search': (words) => `Esto eliminará la búsqueda guardada "${words[0]}". \n\nSeguir?`,

};
